import React, { useState } from 'react';
import { Grid, GridColumn } from 'semantic-ui-react';
import { createPortal } from 'react-dom';
import ExamHeader from '../Header';
import QuestionPage from '../Page';
import ExamFooter from '../Footer';
import QuestionsNav from '../Nav/QuestionsNav';
import ExamSummary from '../../ExamSummary';
import { Consts } from '../../../../res';
import CmaTutorial from '../../ExamTutorial/CmaTutorial';
import { findNextFreqExam, findFreqExamByType } from '../../../../helpers/examHelpers';

const CmaLayout = (props) => {
    const {
        selectedCourse, selectedCourseStruct, Qindex, Q, user, questions, onGoingExam,
        userOnFinishExam, examFinishingLoading, showExamSummary, setShowExamSummary,
        userExamSelectQuestion, FactIndex,
        questionOptionsLoading, questionOptionsError, userExamFlagQuestion, userExamFavQuestion,
        userExamAnswerQuestion, userExamHideSomeAnswers, userExamExcludeOption, userExamHighlightText,
    } = props;

    const [showTutorial, setShowTutorial] = useState(false);

    const renderTutorial = () => {
        return createPortal(
            <div style={{ zIndex: showTutorial ? 999 : -1 }} className="tw-fixed tw-h-screen tw-top-0 tw-start-0 tw-w-screen tw-bg-white">
                <CmaTutorial onGoingExam={onGoingExam} onClose={() => setShowTutorial(false)} />
            </div>,
            document.body
        );
    };

    const nextExam = findNextFreqExam(onGoingExam.parentId, onGoingExam.orderNum);
    const mcqExam = findFreqExamByType(onGoingExam.parentId, Consts.QUESTIONS_TYPES.MCQS);

    return (
        <div className='tw-flex tw-flex-row'>

            {Q && <div className={`${showExamSummary ? "tw-w-[20%]" : "tw-w-0"} tw-h-screen tw-transition-all`}>
                <ExamSummary
                    course={selectedCourse}
                    questions={questions}
                    onSelectQuestion={userExamSelectQuestion}
                    onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                    onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                    summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }}
                    isMockExam={onGoingExam.isMockExam}
                    isViewOnly={onGoingExam.isViewOnly}
                    theme={onGoingExam.theme}
                    Qindex={Qindex}
                />
            </div>}

            <div className={`${showExamSummary ? "tw-w-[77%] tw-ms-auto" : "tw-w-full"} tw-relative tw-h-screen tw-flex tw-flex-col`}>

                <div>
                    <ExamHeader
                        course={selectedCourse}
                        courseStruct={selectedCourseStruct.courseStruct}
                        Qindex={Qindex}
                        Q={Q}
                        user={user}
                        questions={questions}
                        onGoingExam={onGoingExam}
                        onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                        onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                        userOnFinishExam={userOnFinishExam}
                        examFinishingLoading={examFinishingLoading}
                        isMockExam={onGoingExam.isMockExam}
                        summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }}
                        theme={onGoingExam.theme}
                    />
                </div>

                <div className='tw-flex-1 tw-flex tw-flex-row tw-overflow-hidden'>

                    <div className='tw-w-[20%] md:tw-w-[15%] tw-flex tw-flex-row tw-justify-center '>
                        {onGoingExam?.isMockExam && Q && <div className='tw-bg-PRIMARY_05 tw-h-full tw-w-full tw-border-e'>
                            <div className='tw-flex tw-items-end tw-h-full tw-gap-5 tw-flex-col tw-overflow-y-auto'>
                                {mcqExam && <div className='tw-bg-white tw-p-2'>
                                    <p>1</p>
                                    {
                                        [1, 2, 3, 4, 5, 6, 7, 8].map(e => <div key={e} className={`${Q?.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && "tw-bg-SECONDARY_60"} tw-border tw-border-black tw-h-2 tw-w-3`} />)
                                    }
                                </div>}

                                {Q?.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && nextExam &&
                                    Array(nextExam.factsCount || 0).fill(0).map((q, idx) => <div key={idx} className='tw-bg-white tw-p-2'>
                                        <p>{idx + 2}</p>
                                        {
                                            [1, 2, 3, 4, 5, 6, 7, 8].map(e => <div key={e} className={`tw-border tw-border-black tw-h-2 tw-w-3`} />)
                                        }
                                    </div>)}

                                {
                                    questions.filter(q => q.showFactOnly).map((q, idx) => <div key={idx} className='tw-bg-white tw-p-2'>
                                        <p>{idx + 2}</p>
                                        {
                                            [1, 2, 3, 4, 5, 6, 7, 8].map(e => <div key={e} className={`${q.factId === Q?.factId && "tw-bg-SECONDARY_60"} tw-border tw-border-black tw-h-2 tw-w-3`} />)
                                        }
                                    </div>)
                                }

                            </div>
                        </div>}
                        <QuestionsNav
                            Q={Q}
                            questions={questions}
                            Qindex={Qindex}
                            onSelectQuestion={userExamSelectQuestion}
                            isViewOnly={onGoingExam.isViewOnly}
                            showNavList
                            isMockExam={onGoingExam.isMockExam}
                        />
                    </div>

                    <div className='tw-w-[80%] md:tw-w-[85%] tw-overflow-y-auto'>
                        <QuestionPage
                            course={selectedCourse}
                            Q={Q}
                            Qindex={Qindex}
                            FactIndex={FactIndex}
                            onAnswerQuestion={onGoingExam.isViewOnly ? () => { } : userExamAnswerQuestion}
                            loading={questionOptionsLoading}
                            error={questionOptionsError}
                            isMockExam={onGoingExam.isMockExam}
                            isViewOnly={onGoingExam.isViewOnly}
                            theme={onGoingExam.theme}
                            user={user}
                            questions={questions}
                            onGoingExam={onGoingExam}
                            onSelectQuestion={userExamSelectQuestion}
                            onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                            onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                            onHideSomeAnswers={onGoingExam.isViewOnly ? () => { } : userExamHideSomeAnswers}
                            onExcludeOption={onGoingExam.isViewOnly ? () => { } : userExamExcludeOption}
                            userExamHighlightText={onGoingExam.isViewOnly ? () => { } : userExamHighlightText}
                        />
                    </div>

                </div>

                <div>
                    <ExamFooter
                        Q={Q}
                        questions={questions}
                        onSelectQuestion={userExamSelectQuestion}
                        onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                        onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                        isMockExam={onGoingExam.isMockExam}
                        isViewOnly={onGoingExam.isViewOnly}
                        Qindex={Qindex}
                        summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }}
                        userOnFinishExam={userOnFinishExam}
                        examFinishingLoading={examFinishingLoading}
                        onGoingExam={onGoingExam}
                        theme={onGoingExam.theme}
                        showTutorial={showTutorial}
                        setShowTutorial={setShowTutorial}
                    />
                </div>

            </div>

            {onGoingExam?.isMockExam && !onGoingExam?.isViewOnly && renderTutorial()}
        </div>
    );
};

export default CmaLayout;